export default __webpack_public_path__ + "static/media/vilax-footer-logo.2ce3270a.png";